import { RouterConfig } from '@angular/router';
import { SystemManagementComponent } from './system-management.component';
import { TAFBookComponent} from './tafbooks/taf-book.component';
import { StaffingStandardsComponent} from './staffing-standards/staffing-standards.component';
import { GrowthRatesComponent } from './growth-rates/growth-rates.component';
import { TAFBookRoutes } from './tafbooks/taf-book.routes';
import { StaffingStandardsRoutes } from './staffing-standards/staffing-standards.routes';
import { GrowthRatesRoutes } from './growth-rates/growth-rates.routes';
import {TowersTraconsImportStepsRoutes} from './towers-tracons-import/towers-tracons-import-steps/towers-tracons-import-steps.routes';
import {NewYearRolloverRoutes} from './new-year-rollover/new-year-rollover.routes';
import {NewYearRolloverComponent} from './new-year-rollover/new-year-rollover.component';
import {TraconModelRoutes} from './tracon-models/tracon-model.routes';
import {RegionalReviewComponent} from './regional-review/regional-review.component';

import { AuthGuard } from '../authentication/auth-guard.service';

export const SystemManagementRoutes: RouterConfig = [
  { path: 'system-management', component: SystemManagementComponent , canActivate: [AuthGuard]},
  { path: 'tafbooks', component: TAFBookComponent, canActivate: [AuthGuard]},
  { path: 'staffing-standards', component: StaffingStandardsComponent, canActivate: [AuthGuard]},
  { path: 'growth-rates', component:GrowthRatesComponent, canActivate: [AuthGuard]},
  { path: 'new-year-rollover', component:NewYearRolloverComponent, canActivate: [AuthGuard]},
  { path: 'regional-review', component:RegionalReviewComponent, canActivate: [AuthGuard]},
  //{ path: 'tafbook-s1', component: TAFBookS1Component},
  ...TAFBookRoutes,
  ...StaffingStandardsRoutes,
  ...GrowthRatesRoutes,
  ...TowersTraconsImportStepsRoutes,
  ...NewYearRolloverRoutes,
  ...TraconModelRoutes

];



/** WEBPACK FOOTER **
 ** ./app/system-management/system-management.routes.ts
 **/